<template>
    <div class="p-2">
        <div class="alert alert-warning">
            <i class="fa fa-user-alt mr-2"></i>
            Identificando, espere un momento ...

            <i class="fa fa-spinner fa-spin"></i>
        </div>
    </div>
  
</template>

<script>
import servicio from "@/services/servicio-publica"	

export default {
    data(){
        return {

        }
    },
    mounted(){
        window.localStorage.removeItem('tokenDifarmer')
        localStorage.removeItem("RouteTo")
        localStorage.removeItem("RouteToQuery")

        const tk = this.$route.query.tk

        servicio.loginTk(tk).then(r => {
            if (r.value) {
                console.log(r)

                let tokenDifarmer = {}
                
                let tk = r.data.tokenInfo.accessToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")                                

                tokenDifarmer.token = r.data.tokenInfo.accessToken
                tokenDifarmer.expiresAt = r.data.tokenInfo.expiresAt
                tokenDifarmer.refreshToken = r.data.tokenInfo.refreshToken
                tokenDifarmer.user = decodeURIComponent(escape(window.atob(tk)));

                window.localStorage.tokenDifarmer = JSON.stringify(tokenDifarmer)
                
                this.$router.push({ path: r.data.url })								                
                //window.location.href = r.data.url
            } 
        })
    }   
}
</script>

<style>

</style>
